export default safe => {
  console.log(safe); //vue的this对象
  return {
    lazy: true,
    tip: false,
    simplePage: true,
    searchShow: true,
    // searchMenuSpan: 6,
    tree: true,
    border: true,
    /** 表格索引 */
    index: true,
    /** 索引列名 */
    indexLabel: "序号",
    /** 表格搜索显隐按钮 */
    searchShowBtn: true,
    /** 是否启用功能按钮 */
    searchIcon: true,
    searchIndex: 0,
    /** 表格查看按钮 */
    viewBtn: false,
    /** 表格新增按钮 */
    addBtn: false,
    /** 表格删除按钮 */
    delBtn: false,
    /** 表格修改按钮 */
    editBtn: false,
    /** 导出按钮 */
    excelBtn: true,
    /** 表格搜索按钮 */
    // searchBtn: false,
    /** 表格清空按钮 */
    // emptyBtn: false,
    /** 开启拖拽功能 */
    // sortable: true,
    // dragHandler: true,
    // rowSort: true,
    // columnSort: true,
    /** 操作栏 */
    menu: false,
    // menuWidth: 200,
    column: [{
        label: "合伙人账号",
        prop: "partnerPhoneNum",
        /** 当内容过长被隐藏时显示 tooltip */
        overHidden: false,
        // search: true,
        columnBtn: false
        /** 搜索项位置排序，序号越大越靠前 */
        // searchOrder: 1,
      },
      {
        label: "所属公司",
        prop: "partnerCompanyName",
        /** 当内容过长被隐藏时显示 tooltip */
        overHidden: true,
        // slot: true
      },
      {
        label: "设备名称",
        prop: "deviceName",
        overHidden: true,
      },
      {
        label: "设备HID",
        prop: "deviceHid",
        overHidden: true,
      },
      {
        label: "设备UID",
        prop: "deviceUid",
      },
      {
        label: "设备MAC地址",
        prop: "deviceMac",
      },
      {
        label: "绑定账号",
        prop: "userPhoneNum",
      },
      {
        label: "设备绑定时间",
        prop: "createTime",
      },
      {
        label: "",
        prop: "my",
        hide: true,
        showColumn: false,
        search: true,
        display: false,
        menuClassName: "myClass",
        searchslot: true
      }
    ]
  };
};
